import { View, Image } from "@/components/ui";
import QrCode from "@/assets/images/qr-code.jpeg";
import LuceApp from "@/assets/images/luce-app.png";
import { Typography } from "@/components/shared/typography";
import AppStoreSocialBtn from "@/assets/images/app-store.png";
import GooglePlaySocialBtn from "@/assets/images/play-store.png";
import { links } from "@/constants";
import { handleOpenLink } from "@/lib/platform";
import { sendAnalyticData } from "@/lib/monitoring/analytics";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

// junk: triggering the cf deploy

const images = {
  qrcode: QrCode,
  luceapp: LuceApp,
};

export function GetTheApp({
  imageVariant = "qrcode",
}: {
  imageVariant?: "qrcode" | "luceapp";
}) {
  const { isMobile } = useWindowDimensions();
  const sendToRudderStack = async (href: string) => {
    await handleOpenLink(href);
    sendAnalyticData({
      name: "app_download_button_click",
      values: {
        button_location: href,
      },
    });
  };

  return (
    <View className="flex w-full flex-col gap-4 rounded-lg bg-white p-4 shadow-sm">
      <View className="mb-2 flex flex-col gap-y-1">
        <Typography variant="label-lg" color="brand-primary" align="center">
          Get the help you need at your fingertips
        </Typography>
        <Typography
          variant="caption-md"
          color="foreground-intermediate"
          align="center"
        >
          {isMobile
            ? "Download the Luce App to seamlessly book, manage, and pay for your services!"
            : "Scan QR code to get the app now!"}
        </Typography>
      </View>
      <View className="flex flex-col-reverse items-center gap-4 md:flex-col">
        <Image
          src={images[imageVariant]}
          className={
            imageVariant === "qrcode" ? "size-[88px] max-w-full" : "w-full"
          }
        />
        <View className="align-center flex flex-col items-center gap-2">
          {!isMobile && (
            <Typography variant="caption-md" color="brand-primary">
              Get the app now!
            </Typography>
          )}
          <View className="flex gap-2">
            <View
              onClick={() => sendToRudderStack(links.appStoreClientApp)}
              className="cursor-pointer"
            >
              <Image src={AppStoreSocialBtn} />
            </View>
            <View
              onClick={() => sendToRudderStack(links.googlePlayClientApp)}
              className="cursor-pointer"
            >
              <Image src={GooglePlaySocialBtn} />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}
